// Placeholder for theme.js - Add your custom JavaScript here

// JavaScript from individual section files (like sliders, timers) 
// can be consolidated here or kept within their respective sections 
// if they are self-contained and use Liquid to output settings.

document.addEventListener("DOMContentLoaded", function() {
  console.log("Clarity Conscious Shopify Theme JS Loaded");
  // Add global theme scripts here if needed

  // Hero Section Cycling Text
  const heroCyclingTextContainers = document.querySelectorAll("[id^=\"hero-cycling-text-\"]");
  heroCyclingTextContainers.forEach(container => {
    const texts = container.querySelectorAll(".cycling-text");
    let currentIndex = 0;
    if (texts.length > 0) {
      texts[currentIndex].classList.add("active");
      setInterval(() => {
        texts[currentIndex].classList.remove("active");
        currentIndex = (currentIndex + 1) % texts.length;
        texts[currentIndex].classList.add("active");
      }, 3000);
    }
  });

  // Product Image Slider
  const productImageSliders = document.querySelectorAll("[id^=\"product-image-slider-\"]");
  productImageSliders.forEach(sliderContainer => {
    const slider = sliderContainer.querySelector(".slider-wrapper-clarity");
    if (slider) {
      const slides = slider.querySelectorAll(".slide-clarity");
      let currentIndex = 0;
      const slideCount = slides.length;
      if (slideCount > 0) {
        setInterval(() => {
          currentIndex = (currentIndex + 1) % slideCount;
          slider.style.transform = `translateX(-${currentIndex * 100}%)`;
        }, 2000);
      }
    }
  });

  // Testimonial Slider
  const testimonialSliders = document.querySelectorAll("[id^=\"testimonial-slider-\"]");
  testimonialSliders.forEach(sliderContainer => {
    const slides = sliderContainer.querySelectorAll(".testimonial-slide-clarity");
    let currentSlide = 0;
    if (slides.length > 0) {
      slides[currentSlide].classList.add("active");
      setInterval(() => {
        slides[currentSlide].classList.remove("active");
        currentSlide = (currentSlide + 1) % slides.length;
        slides[currentSlide].classList.add("active");
      }, 4000);
    }
  });

  // Offer Countdown Timer
  const countdownElements = document.querySelectorAll("[id^=\"countdown-timer-clarity-\"]");
  countdownElements.forEach(countdownElement => {
    const offerEndDate = new Date();
    // Retrieve days from a data attribute or section setting if dynamic
    const timerDays = parseInt(countdownElement.dataset.timerDays) || 8; 
    offerEndDate.setDate(offerEndDate.getDate() + timerDays);
    const expiredText = countdownElement.dataset.expiredText || "OFFER EXPIRED";

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = offerEndDate.getTime() - now;

      if (distance < 0) {
        clearInterval(timer);
        countdownElement.innerHTML = expiredText;
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownElement.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }, 1000);
  });

});

